import React from 'react';

import { Button, Group, Stack, Text } from '@mantine/core';
import useDeleteStaff from 'hooks/staff/useDeleteStaff';
import { Staff, StaffList } from 'types';
import notificationHandler from 'utils/notifications';

interface IDeleteStaffModalProps {
  staff: Staff | StaffList;
  handleClose: () => void;
}

const DeleteStaffModal = ({ staff, handleClose }: IDeleteStaffModalProps): JSX.Element => {
  const deleteStaffMutation = useDeleteStaff();

  const handleDelete = (): void => {
    const { successNotification, errorNotification } = notificationHandler();
    deleteStaffMutation.mutate(staff.staffId, {
      onSuccess: () => {
        successNotification(
          'Staff delete success',
          `${staff.firstName} ${staff.lastName} successfully deleted.`,
        );
        handleClose();
      },
      onError: error => {
        errorNotification('Staff delete failed', error.response?.data.message);
      },
    });
  };

  return (
    <Stack>
      <Text>{`Are you sure you want to delete ${staff.firstName} ${staff.lastName}?`}</Text>
      {staff.isCoach && (
        <Text>
          Their upcoming appointments and classes will stay on the calendar as No Coach until you assign
          another coach.
        </Text>
      )}
      <Text color='dimmed'>This action cannot be undone.</Text>
      <Group position='right'>
        <Button
          onClick={handleDelete}
          color='red'
          loading={deleteStaffMutation.isLoading}
          data-cy='deleteStaffButton'
        >
          Delete
        </Button>
      </Group>
    </Stack>
  );
};

export default DeleteStaffModal;
